import React from 'react';

export default class RenderIf extends React.Component{
    render(){
        if(this.props.test){
            return this.props.children;
        }else{
            return this.props.else || false;
        }
    }
}